import OptionGenerator from '../Generic/Options';

export default OptionGenerator(
    'clients',
    ({isSuperUser}, obj) => {
        return isSuperUser;
    },
    (authStore, props) => {
        if (
            props &&
            props.noDefault
        ) {
            return [];
        } else {
            return [{
                key: 'All Clients',
                value: 'global',
                text: 'All Clients'
            }];
        }
    }, 
    (props: any)  => {
        const ret = Object.assign({}, props);
        if (ret.noDefault) {
            delete ret.noDefault;
        }
        return ret;
    }
);


// WEBPACK FOOTER //
// ./src/container/Client/ClientOptions.tsx